export const ImageProcessingEngineVersion = 36;
export const DoSmallDetailsPart = true;
export const ShowAIPreviewOption = true;
